import { ArrowUp } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { AGENT } from "@/data/property";
import { scrollToTop, scrollToId } from "@/lib/smooth";

export default function Footer() {
  return (
    <footer id="footer" data-testid="footer-section" className="bg-[#0B0C0E] text-zinc-300">
      <div className="mx-auto max-w-7xl px-4 pt-16 sm:px-6 lg:px-8 lg:pt-20">
        <div className="flex flex-col gap-6 border-b border-zinc-800/60 pb-12 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <h3 className="font-display text-2xl font-bold text-white sm:text-3xl">
              Interested in 52-461 Beechwood Place?
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">
              Send an enquiry below, or reach {AGENT.name} directly at{" "}
              <a
                href={`mailto:${AGENT.email}`}
                data-testid="footer-email-link"
                className="font-semibold text-bronze hover:underline"
              >
                {AGENT.email}
              </a>
              .
            </p>
          </div>
          <button
            data-testid="footer-contact-cta"
            onClick={() => scrollToId("contact")}
            className="flex-none rounded-full bg-bronze px-6 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-bronze-dark"
          >
            Enquire Now
          </button>
        </div>
      </div>

      <div className="relative overflow-hidden border-t border-zinc-800/60">
        <p className="select-none whitespace-nowrap text-center font-display text-[7vw] font-extrabold leading-none tracking-tight text-white/5">
          461 BEECHWOOD
        </p>
        <div className="absolute left-1/2 top-8 -translate-x-1/2">
          <LogoMark className="h-14 w-14" />
        </div>
      </div>

      <div className="border-t border-zinc-800/60">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 py-8 text-xs text-zinc-500 sm:px-6 md:flex-row lg:px-8">
          <p>
            © 2026 · Listed by {AGENT.name}, {AGENT.brokerage} · Sample imagery shown for
            illustration and will be replaced with the listing's own photos.
          </p>
          <div className="flex items-center gap-5">
            <button
              onClick={() => scrollToId("overview")}
              data-testid="footer-top-link"
              className="transition-colors duration-200 hover:text-white"
            >
              Back to top
            </button>
            <button
              onClick={scrollToTop}
              data-testid="back-to-top-button"
              aria-label="Back to top"
              className="rounded-full border border-zinc-700 p-2.5 text-zinc-300 transition-colors duration-200 hover:bg-white/10"
            >
              <ArrowUp size={16} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
